import { cn } from "@app/ui/lib/Utils";
import { LocaleSelect } from "./LocaleSelect";

export interface AuthLocaleSelectProps {
  /** 현재 UI 언어 ("ko" | "en"). onLocaleChange 와 함께 주면 언어 드롭다운을 노출한다. */
  locale?: string;
  /** 브라우저 언어 감지가 사용자 기대와 어긋났을 때 로그인 전에도 언어를 바꿀 수 있게 한다. */
  onLocaleChange?: (locale: string) => void;
  className?: string;
}

/**
 * 세션 없는 인증 화면 우측 상단의 언어 선택기. 언어는 브라우저 설정으로 자동 판별되지만
 * (@app/i18n getLocalePreference) 그 결과가 사용자 기대와 어긋나도 로그인 전에는 설정 화면에
 * 못 들어가므로 오른쪽 위에서 바로 바꿀 수 있게 둔다. locale/onLocaleChange 가 둘 다 있을 때만
 * 렌더한다. 부모 컨테이너는 반드시 relative 여야 한다.
 */
export function AuthLocaleSelect({ locale, onLocaleChange, className }: AuthLocaleSelectProps) {
  if (!locale || !onLocaleChange) return null;
  return (
    <div className={cn("absolute right-6 top-6", className)}>
      <LocaleSelect value={locale} onChange={onLocaleChange} />
    </div>
  );
}
AuthLocaleSelect.displayName = "AuthLocaleSelect";
